import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/Common/withRouter";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar-1.jpg";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
import { getUserByIdApi } from "service/api";
import { useNavigate } from "react-router-dom";

const UserProfile = () => {

  //meta title
  document.title = "Profile | Ai in realstate";

  const dispatch = useDispatch();

  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);
  const navigate = useNavigate();
  const { error, success } = useSelector(state => ({
    error: state.Profile.error,
    success: state.Profile.success,
  }));
  const userRole = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).role
    : null;

  useEffect(() => {

    if (!localStorage.getItem("token")) {
      navigate("/login");
      return;
    }

    const storedUser = localStorage.getItem("user");

    if (!storedUser) return;

    const parsedUser = JSON.parse(storedUser);

    getUserByIdApi(parsedUser.id)
      .then((res) => {
        if (res.data.success) {
          const user = res.data.data;
          setname(user.username);
          setemail(user.email);
          setidx(user.id);
        }
      })
      .catch(() => {
        alert("Failed to load profile data");
      });
  }, []);


  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: name || '',
      idx: idx || '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values));
    }
  });

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (!confirmLogout) return;

    // Clear auth data
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("authUser");

    // Optional: clear everything
    // localStorage.clear();

    // Redirect and block back navigation
    navigate("/login", { replace: true });
  };



  const profileMenus = [
    {
      label: "Dashboard",
      path: "/builder-dashboard",
      icon: "bx bx-gift",
      roles: ["builder"]
    },
    {
      label: "Walkings",
      path: "/walking-form",
      icon: "bx bx-gift",
      roles: ["admin"]
    },
    {
      label: "Package",
      path: "/package-form",
      icon: "bx bx-gift",
      roles: ["admin"]
    },
    {
      label: "Feedback",
      path: "/feedback-for-walkings",
      icon: "bx bx-gift",
      roles: ["admin"]
    },
    {
      label: "Add Web Stories",
      path: "/AddWebstories",
      icon: "bx bx-news",
      roles: ["admin"]
    },
    {
      label: "Monthly Updates",
      path: "/AddMonthUpdate",
      icon: "bx bx-calendar",
      roles: ["admin"]
    },
    {
      label: "Add Property",
      path: "/Addproperty",
      icon: "bx bx-home",
      roles: ["admin"]
    },
    {
      label: "Add Agents",
      path: "/add_agents",
      icon: "bx bx-user-plus",
      roles: ["admin"]
    },
    {
      label: "Property Summary",
      path: "/UpdatepropertySummary",
      icon: "bx bx-bar-chart",
      roles: ["admin"]
    },
    {
      label: "Add Builders",
      path: "/add_builders",
      icon: "bx bx-buildings",
      roles: ["admin"]
    },
    {
      label: "Categories",
      path: "/AddCategories",
      icon: "bx bx-category",
      roles: ["admin"]
    },
    {
      label: "Festive Form",
      path: "/festive",
      icon: "bx bx-gift",
      roles: ["admin"]
    },
    {
      label: "Properties",
      path: "/",
      icon: "bx bx-gift",
      roles: ["Customer"]
    },

  ];



  return (
    <React.Fragment>
      <div className="page-content text-light">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Aiinrealestate" breadcrumbItem="Profile" />
          <Row>
            {/* LEFT MENU */}
            <Col lg="3" md="4" sm="12">
              <Card
                style={{
                  background: "rgba(255,255,255,0.08)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "16px",
                  border: "1px solid rgba(255,255,255,0.2)",
                  color: "#fff",
                  minHeight: "400px"
                }}
              >
                <CardBody>
                  <h5 style={{ marginBottom: "20px", fontWeight: "600" }}>
                    <i className="bx bx-grid-alt me-2" />
                    Menu
                  </h5>

                  {profileMenus
                    .filter(menu => menu.roles.includes(userRole))
                    .map((menu, index) => (

                      <div
                        key={index}
                        onClick={() => navigate(menu.path)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          padding: "10px 14px",
                          borderRadius: "10px",
                          cursor: "pointer",
                          marginBottom: "8px",
                          transition: "all 0.3s ease",
                          background: "rgba(255,255,255,0.05)"
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.background = "#6f42c1";
                          e.currentTarget.style.boxShadow =
                            "0 0 15px rgba(111,66,193,0.6)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.background =
                            "rgba(255,255,255,0.05)";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <i className={menu.icon} style={{ fontSize: "18px" }} />
                        <span>{menu.label}</span>
                      </div>
                    ))}
                </CardBody>
              </Card>
            </Col>

            {/* RIGHT PROFILE PANEL */}
            <Col lg="9" md="8" sm="12">
              {/* PROFILE CARD */}
              <Card
                style={{
                  background: "rgba(255,255,255,0.08)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "16px",
                  border: "1px solid rgba(255,255,255,0.2)",
                  color: "#fff"
                }}
              >
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "90px",
                        height: "90px",
                        borderRadius: "50%",
                        background: "#6f42c1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 0 20px rgba(111,66,193,0.6)"
                      }}
                    >
                      <i className="bx bx-user" style={{ fontSize: "45px", color: "#fff" }} />
                    </div>
                    <div className="ms-4" style={{ flexGrow: 1 }}>
                      <h3>{name}</h3>
                      <p style={{ opacity: 0.8 }}>{email}</p>
                      <span
                        style={{
                          background: "rgba(111,66,193,0.2)",
                          padding: "6px 14px",
                          borderRadius: "14px",
                          fontSize: "13px"
                        }}
                      >
                        {`Role: ${localStorage.getItem("user")
                          ? JSON.parse(localStorage.getItem("user")).role
                          : ""
                          }`}
                      </span>
                    </div>

                    <div>
                      <Button
                        onClick={handleLogout}
                        style={{
                          background: "rgba(220, 53, 69, 0.9)",
                          border: "none",
                          borderRadius: "12px",
                          padding: "8px 18px",
                          color: "#fff",
                          fontWeight: "600",
                          transition: "all 0.3s ease"
                        }}
                        onMouseOver={(e) => {
                          e.target.style.background = "#dc3545";
                          e.target.style.boxShadow = "0 0 15px rgba(220,53,69,0.7)";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.background = "rgba(220, 53, 69, 0.9)";
                          e.target.style.boxShadow = "none";
                        }}
                      >
                        <i className="bx bx-log-out me-2"></i>
                        Logout
                      </Button>
                    </div>

                  </div>
                </CardBody>
              </Card>

              {/* EDIT PROFILE */}
              <Card
                className="mt-4"
                style={{
                  background: "rgba(255,255,255,0.08)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "16px",
                  border: "1px solid rgba(255,255,255,0.2)",
                  color: "#fff"
                }}
              >
                <CardBody>
                  <h5 className="mb-3">Update Profile</h5>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                    }}
                  >
                    <div className="mb-3">
                      <Label>User Name</Label>
                      <Input
                        name="username"
                        type="text"
                        placeholder="Enter User Name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.username || ""}
                        style={{
                          background: "rgba(255,255,255,0.1)",
                          color: "#fff",
                          border: "1px solid rgba(255,255,255,0.2)"
                        }}
                        invalid={
                          validation.touched.username &&
                            validation.errors.username
                            ? true
                            : false
                        }
                      />
                      <FormFeedback>
                        {validation.errors.username}
                      </FormFeedback>
                      <Input name="idx" value={idx} type="hidden" />
                    </div>

                    <Button
                      type="submit"
                      style={{
                        background: "#6f42c1",
                        border: "none",
                        borderRadius: "12px",
                        padding: "8px 20px"
                      }}
                    >
                      Save Changes
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
